import React, { useState, useCallback } from 'react';
import {
  MenuButton,
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
} from '@fluentui/react-components';
import { Edit16Filled } from '@fluentui/react-icons';

import { useIsReadOnlyUser } from './use-is-read-only-user';

export interface IDialogEditButtonProps {
  title: string;
  ChildComponent: React.FunctionComponent<{ closeDialog: () => void; }>;
  buttonAriaLabel: string;
}

export const DialogEditButton: React.FunctionComponent<IDialogEditButtonProps> = ({
  title,
  ChildComponent,
  buttonAriaLabel,
}: IDialogEditButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const isReadOnly = useIsReadOnlyUser();

  const closeDialog = useCallback(() => setIsOpen(false), [setIsOpen]);

  const onOpenChange = useCallback((_e, data) => {
    setIsOpen(data.open);
  }, [setIsOpen]);

  return (
    <Dialog modalType="modal" open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger disableButtonEnhancement>
        <MenuButton
          appearance="subtle"
          icon={<Edit16Filled />}
          className="ba-status-summary-card-menu-button"
          aria-label={buttonAriaLabel}
          disabled={isReadOnly}
        />
      </DialogTrigger>
      <DialogSurface>
        <DialogBody className="edit-dialog-body">
          <DialogTitle className="edit-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <ChildComponent closeDialog={closeDialog} />
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
